angular.module('labApp').factory("StSampleIdFactory", function ($resource) {
    return $resource('api/v1.0/lab/st-sample-ids/:slug/', {slug: '@slug'});
});
